<template>
<!-- <v-responsive 
	min-width="900" 
	max-width="1400"> -->
  <v-container
	pt-4
	mt-5
	pl-1
	pr-1
	fluid>
	<v-layout 
		row
		>
<!-- START GROUP EDIT -->
		<v-flex>
			<edit-group 
				v-if="loaded && groupId && groupName"
				:key="groupName" 
				:group-id="groupId"
				/>
		</v-flex>	
	<!-- END GROUP EDIT -->

		<v-flex>
			<v-btn 
				:color="strongColor"
				:to="{
				name: 'group-edit-clients',
				params: {
					groupId: groupId
				}
				}"
				dark
				>Edit Group Members
			</v-btn>
		</v-flex>

<!---- START DISPLAY OPTIONS --->
		<v-flex>
			<div v-if="loaded">
				<groups-options/>
			</div>
		</v-flex>
		<v-flex>							
			<v-btn
			:color="strongColor"
			dark
			@click="downloadWithCSS">
			Download PDF
			</v-btn>
		</v-flex>


<!-- END DISPLAY OPTIONS -->
	</v-layout>
		<v-layout 
			align-end 
			fill-height
			>

			<v-flex 
				xs12>
				<div
					v-if="loaded && currentGroupClients !== null && currentGroupClients.length >= 2 && bubbleCheckedAttrs !== null && bubbleCheckedAttrs.length >= 1">
					<v-card>
	<!---- START TOOLBAR ---> 
						<v-toolbar
							:color="strongColor"
							flat
							dark>	
							<v-layout 
								justify-center>
								<v-flex 
									offset-lg1>
									<v-toolbar-title
										:key="groupName" 
										class="text-xs-center"
										style="display: inline-block;">
										<div class="title">	Comparison of RMP Scores for {{ groupName }}  </div>
									</v-toolbar-title>
								</v-flex>
							</v-layout>
						</v-toolbar>
					<v-flex 
						xs12
						mb-4>
						<div ref="bubble">
							<div 
								id="bubble2">
								<vue-bubble-chart
									id="groupChart"
									:key="groupName"
									:chart-width="chartWidth"
									:chart-height="chartHeight"
									:client-count="clientCount"
									:styles="myStyles"
								/>
							</div>
						</div>
					</v-flex>
				</v-card>
			</div>
			<div v-else-if="loaded && currentGroupClients !== null && currentGroupClients.length === 0">
				No Clients in Current Group.
			</div>
			<div v-else-if="loaded && currentGroupClients !== null && currentGroupClients.length === 1">
				Only 1 client in current group.
			</div>
			 <div v-else-if="loaded && currentGroupClients !== null && bubbleCheckedAttrs != null && bubbleCheckedAttrs.length === 0">
				Please select 1 or more Basic Desires for group comparison.
			</div>
			<div v-else>
				<v-progress-circular
					indeterminate
					color="primary"
					/>
			</div>
		</v-flex>
	</v-layout>
  </v-container>
  <!-- </v-responsive> -->
</template>
<script>
import {mapState} from 'vuex'
import jsPDF from 'jspdf'
import GroupsService from '@/services/GroupsService'
import ClientsGroupService from '@/services/ClientsGroupService'
import ClientsService from '@/services/ClientsService'
import { RMP_LOGO_SMALL } from '@/assets/rmp_logo.js'
import { STRONG_COLOR, WEAK_COLOR, AVERAGE_COLOR } from '@/components/globals/consts'
import EventBus from '@/main.js'
import html2canvas from 'html2canvas'

export default {
	components: {
		VueBubbleChart: () => import("./VueBubbleChart"),
		GroupsOptions: () => import("./GroupsOptions"),
		EditGroup: () => import("@/components/EditGroup")
	},
	data () {
		return {
			group: {},
			clientsGroup: [],
			loaded: false,
			chartWidth: 800,
			chartHeight: 800,
			averageColor: AVERAGE_COLOR,
			weakColor: WEAK_COLOR,
			strongColor: STRONG_COLOR,
			rmpLogoSmall: RMP_LOGO_SMALL,
			clientCount: null
		}
	},
	computed: {
		...mapState([
			'isUserLoggedIn',
			'user',
			'route',
			'currentGroupClients',
			'groupName',
			'groupId',
			'bubbleCheckedAttrs'
		]),
		myStyles () {
		  if (this.bubbleCheckedAttrs !== undefined) {
			let b = this.bubbleCheckedAttrs.length
			if (b <= 10 && b>0) {
				let x = 700+(b-1)*25
				return {
					width: `${x}px`,
					// 'margin-left': `20px`,
					position: `absolute`
				}
			} else {
				return null
			}
		  }
		}
	},
	 watch: {
		'currentGroupClients': {
			immediate: true,
			async handler () {
			if (this.clients !== null) {
				await this.emitMethod('clientsChange', this.clients)
			}
      	}	
	}
  },
	async created () {
		await this.$store.dispatch('setGroupId', Number(this.route.params.groupId))
		await this.loadClients()
	},
	async mounted () {
		if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
		}
		await EventBus.$on('editGroupClients',  (val) => {
			this.loadClients()
		})
		await this.loadClients()
		this.loaded = true
	},
  async beforeDestroy() {
    try {		
	 	await this.$store.dispatch('setCurrentGroupClients', []) 

    } catch (err) {
      console.log(err);
    }
  },


	methods: {
		async emitMethod (name, value) {
			await EventBus.$emit(name, value)
		},
		async loadClients () {
			try {
				this.group = (await GroupsService.show(this.groupId)).data
				await this.$store.dispatch('setGroupName', this.group.name)
				this.clientsGroup = (await ClientsGroupService.show(this.groupId)).data
				let tempClientArr = []
				//if (clientsGroup) {
					for (let client of this.clientsGroup) {			
						let x = {}
						x.name = client.Client.name
						x.id = client.Client.id
						x.clientsGroupId = client.id
						x.scores = (await ClientsService.show(x.id)).data
						tempClientArr.push(x)
					}
					this.height = 300+(50*tempClientArr.length)
					this.clientCount =  tempClientArr.length

					/// for some reason can't realy control width effectively here
					let newTempClients = tempClientArr.slice()
					await this.$store.dispatch('setCurrentGroupClients', newTempClients)
				//}

			} catch (e) {
				console.log(`error in ${e}`)
			}
		},


    async downloadWithCSS () {

		let currYear = new Date().getFullYear();
		//let paperWidth = 612;
		//let paperHeight = 792;
		let clientCount = this.clientCount
		let logoHeight = 70;
		let logoWidth = 120;
		let footerMargin = 36;
		let topMargin = 36;
		let leftMargin = 36;
		let rightMargin = 36;
		let gpName= this.groupName
		
		let canvas = await html2canvas(document.getElementById('bubble2'))//.then(function(canvas){

		var img = canvas.toDataURL("image/png") 


		let pdfCanvasWidth = 792-leftMargin

		let wRatio = canvas.width / pdfCanvasWidth
		let canWtoH = canvas.width / canvas.height

		let newW = canvas.width*(1/wRatio)
		let newH =  canvas.height*(1/wRatio)
		console.log(`${wRatio} ${canWtoH} ${newW} x ${newH}`)


		let paperHeight = newH+topMargin+logoHeight+20+100
		let paperWidth = newW+leftMargin
				//console.log(`${newW} x ${newH}`)
				//let newH = canvas.height+topMargin*2+70
		let doc = await new jsPDF({orientation: 'l',unit: 'pt',format: [paperWidth, paperHeight] , compress:true, putOnlyUsedFonts: true})
		doc.addImage(
		this.rmpLogoSmall,
		"PNG",
		topMargin,
		leftMargin,
		logoWidth,
		logoHeight
		)

		doc.setFontSize(12)
		doc.text(
			`Comparison of RMP Scores for ${this.groupName}`,
			(paperWidth/2+25),
			(topMargin+logoHeight+20),
			"center"
		)	

		doc.addImage(img,'JPEG',leftMargin/2,135,newW, newH);
		
		doc.setFontSize(10)
        doc.text(
       `©2000-${currYear}. IDS Publishing Corporation. All rights reserved.`,
        paperWidth/2+25,
        paperHeight-36, 
        "center"
      )
        doc.save(`${this.groupName}.pdf`);
    },
	}
}
</script>

<style scoped>
.v-toolbar {
	 background-color: #0065BD;
}
.title {
	display: inline-block;
}
.group-button {
  background-color: #0065BD;
}

</style>



// WEBPACK FOOTER //
// src/components/ViewGroup/ViewGroupIndex.vue